import type { ExternalTableSchema } from '@packages/table-builder';

/** Column prefs: useGetTablePreferences (persistenceKey below) — DynamicTableV2 built-in */
export const rsuAwardApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'RSU Awards Approval',
    entity: 'RSU Award Approval',
    description: 'Review and approve pending RSU award requests.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/r-sUAward-approval/r-sUAward-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      ApprovalStatusIds: 'filters.approvalStatusId',
      RSUAcceptance: 'filters.optionAcceptance',
    },
    filters: [
      {
        name: 'approvalStatusId',
        semanticId: 'approvalStatusId',
        placeholder: 'Approval Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/r-sUAward-approval/r-sUAward-statuses',
          labelField: 'name',
          valueField: 'id',
        },
        // @ts-expect-error — Toolbar supports additionalOption at runtime
        additionalOption: { label: 'All', value: 0 },
      },
      {
        name: 'optionAcceptance',
        semanticId: 'optionAcceptance',
        placeholder: 'Accept Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/r-sUAward-approval/r-sUAcceptances',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'participantName',
      header: 'Participant Details',
      type: 'couple',
      sortable: true,
      width: 180,
      couple: {
        titleField: 'participantName',
        subtitleField: 'employeeId',
      },
    },
    {
      field: 'grantNo',
      header: 'Award #',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'grantName',
      header: 'Grant Name',
      type: 'text',
      sortable: true,
      width: 230,
    },
    {
      field: 'status',
      header: 'Approval Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Approved: 'success',
          Cancelled: 'error',
          Rejected: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'unitsGranted',
      header: 'Awarded Units',
      type: 'number',
      sortable: true,
      width: 180,
      align: 'center',
    },
    {
      field: 'issueDate',
      header: 'Grant Date',
      type: 'date',
      sortable: true,
      width: 180,
      align: 'center',
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'vestingSchedule',
      header: 'Vesting Schedule',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'isAccepted',
      header: 'Accept Status',
      type: 'custom',
      sortable: true,
      width: 180,
      align: 'center',
      renderer: 'awardAcceptStatus',
    },
    {
      field: 'grantPrice',
      header: 'Grant Price',
      type: 'currency',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'vestingStartDate',
      header: 'Vesting Start Date',
      type: 'date',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'nextVestingDate',
      header: 'Next Vesting Date',
      type: 'date',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'vestedUnits',
      header: 'Vested Units',
      type: 'number',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
    {
      field: 'unvestedUnit',
      header: 'Unvested Units',
      type: 'number',
      width: 180,
      align: 'center',
      visibility: 'picker',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_RSU_AWARD_APPROVAL', label: 'View' },
      { id: 'APPROVE_RSU_AWARD_APPROVAL', label: 'Approve' },
      { id: 'REJECT_RSU_AWARD_APPROVAL', label: 'Reject', variant: 'danger' },
      { id: 'VIEW_COMMENTS_RSU_AWARD_APPROVAL', label: 'View Comments' },
    ],
    bulk: [
      { id: 'BULK_APPROVE_RSU_AWARD_APPROVAL', label: 'Approve' },
      { id: 'BULK_REJECT_RSU_AWARD_APPROVAL', label: 'Reject', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: true, placeholder: 'Search Keywords' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: {
      keyField: 'id',
      selectable: { field: 'status', operator: 'EQUAL', value: 'Pending' },
    },
    columnPreferences: {
      persistenceKey: 'RSU Award Approval',
      resizable: true,
      reorderable: true,
    },
  },
};
